<template>
	<div class="form-designer-content">
		<Accordion title="Client Input Fields" v-model="accordion.first">
			<template slot="body-content">
				<div class="customer-input-fields">
					<FieldPromptDragableList
						v-model="inputFieldsData"
						:editMode="true"
					/>
				</div>
			</template>
		</Accordion>
		<!-- DEV NOTE: This section, Pre-assign Customers, is exactly the same on Laser and Impact forms. IF you move this to its own file let us know so we can
			review that the styles and cleaned up are moved accordingly. If not, this comment can just be removed. -->

		<Accordion
			title="Pre-Assign Clients"
			v-model="accordion.second"
			v-if="showPreAssignCustomer"
		>
			<template slot="body-content">
				<div class="pre-assign-customers">
					<p class="pre-assign-customers__description">
						Pre-assign clients to a form before it is Published.
						Once pre-assigned clients are Published, they can not
						be unassigned. However, they can be "disabled" from
						using the form.
					</p>
					<CustomerAssignation v-model="source.customers" />
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import FieldPromptDragableList from '@/views/form-designer/field-prompt-draggable-list.vue';
import CustomerAssignation from '@/sections/forms/views/customer-assignation.vue';
import Accordion from '@/components/shells/accordion/accordion';
import { getNextNumber as getLastNegativeId } from '@/utils/function';
import Vue from 'vue';

export default {
	name: 'LaserFormContent',
	components: {
		FieldPromptDragableList,
		CustomerAssignation,
		Accordion
	},
	model: {
		prop: 'source'
	},
	props: {
		source: {
			type: Object
		},
		editionMode: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			accordion: {
				first: false,
				second: false
			},
			inputFieldsData: []
		};
	},
	methods: {
		addInputField() {
			this.inputFieldsData.push({
				keyboardPrompt: '',
				order: this.inputFieldsData.length,
				id: getLastNegativeId(
					...this.inputFieldsData.map(item => {
						return item.id;
					}),
					true
				)
			});
		}
	},
	computed: {
		showPreAssignCustomer() {
			if (this.editionMode) {
				return !this.published && this.source.status === 'U';
			}

			return true;
		},
		isDesktopDevice() {
			return this.screenSize.desktop;
		}
	},
	watch: {
		source: {
			deep: true,
			immediate: true,
			handler(obj) {
				if (obj.inputFields && obj.inputFields.length) {
					if (
						JSON.stringify(obj.inputFields) !==
						JSON.stringify(this.inputFieldsData)
					) {
						this.inputFieldsData = [...obj.inputFields];
					}
				}
			}
		},
		inputFieldsData: {
			deep: true,
			handler(list) {
				Vue.set(this.source, 'inputFields', list);
			}
		},
		isDesktopDevice: {
			immediate: true,
			handler(val) {
				if (val) {
					Object.assign(this.accordion, {
						first: true,
						second: true
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
  * Laser Form content
  * Can use SCSS variables = TRUE
*/

.form-designer-content {
	@include mq($until: sm-l) {
		border-top: 1px solid $neutral-3;
		padding: $padding-md 0 $padding-sm;
	}

	&__inputs {
		margin-bottom: $gutter-xl;
	}

	&__customers-fields {
		display: grid;
		column-gap: $gutter-xl;
		grid-template-columns: 1fr;
		justify-content: space-between;

		@include mq($from: md) {
			grid-template-columns: 1fr 1fr;
		}
	}

	&__available-customers,
	&__selected-customers {
		display: flex;
		flex-direction: column;
		padding: $padding-md;

		> :not(:first-child) {
			flex-grow: 2;
		}
	}

	&__customers-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: $default-font-size - 2px;
		margin-bottom: $gutter-sm;
	}

	&__customers-title {
		font-size: inherit;
		font-weight: $medium-font-weight;
	}

	&__input-fields {
		padding: $padding-md;
	}
	&__input-btn {
		margin: 0 0 $gutter-xl;
	}
}

/*------------------------------------*\
  #PRE-ASSIGN CUSTOMERS
\*------------------------------------*/

.pre-assign-customers {
	padding: $padding-md;

	&__description {
		font-size: 14px;
	}
}
</style>
